import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { useAiStream } from "@/lib/ai";
import { Panel } from "@/components/common";

export const AiHoursSummary = ({ weekStart }) => {
  const stream = useAiStream();
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setText("");
  }, [weekStart]);

  const run = async () => {
    setBusy(true);
    setText("");
    try {
      await stream(`/ai/hours-summary?week_start=${weekStart}`, {}, setText);
    } catch (e) {
      toast.error(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Panel className="mt-4 border-[#FF5A36]/30" data-testid="ai-hours-summary">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="font-semibold text-lg flex items-center gap-2"><Sparkles className="h-5 w-5 text-[#FF5A36]" />AI-samenvatting</h2>
          <p className="text-sm text-slate-500">Over- en onderuren, vergeten uitklokken en actiepunten.</p>
        </div>
        <Button onClick={run} disabled={busy} variant="outline" className="rounded-full" data-testid="ai-hours-summary-button">
          {busy ? "Bezig…" : text ? "Opnieuw maken" : "Maak samenvatting"}
        </Button>
      </div>
      {text && <p className="mt-4 text-sm text-slate-800 whitespace-pre-wrap" data-testid="ai-hours-summary-text">{text}</p>}
    </Panel>
  );
};
